// src/components/MainHeading.jsx
import React from "react";
import "./MainHeading.css"; // Ensure you create and import a CSS file for additional styling if needed
import StudentDetails from "./StudentDetails";

const MainHeading = () => {
  return (
    <>
      <StudentDetails />
    </>
  );
};

export default MainHeading;
